import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { GeoPoint } from '@core/models/geo.state';
import { mapStoreResponse, mapStoreWithDistanceResponse } from '@core/models/store.mapper';
import { StoreResponse, StoreWithDistanceResponse } from '@core/models/store.response';
import { StoreState, StoreWithDistanceState } from '@core/models/store.state';
import { ApiService } from '@core/services/api.service';

import { StoreRepository } from './store.repository';

@Injectable()
export class StoreHttpRepository implements StoreRepository {
  private readonly api = inject(ApiService);

  getById(id: number): Observable<StoreState | null> {
    return this.api
      .get<StoreResponse | null>(`stores/${id}`)
      .pipe(map(response => (response ? mapStoreResponse(response) : null)));
  }

  listByTenant(tenantId: number): Observable<StoreState[]> {
    return this.api
      .get<StoreResponse[]>(`tenants/${tenantId}/stores`)
      .pipe(map(stores => stores.map(mapStoreResponse)));
  }

  nearby(origin: GeoPoint, radiusMi: number): Observable<StoreWithDistanceState[]> {
    const params = new HttpParams().set('OriginLat', origin.lat).set('OriginLng', origin.lng).set('RadiusMi', radiusMi);
    return this.api
      .get<StoreWithDistanceResponse[]>('stores/nearby', params)
      .pipe(map(stores => stores.map(mapStoreWithDistanceResponse)));
  }
}
